import type { ReactNode } from 'react';

import { createContext } from 'react';

export const HeaderComponentsContext = createContext<ReactNode>([]);
